import type {
  PartnerProduct,
  PartnerProductDetails,
  Slice,
} from '@setplex/tria-api'
import type {
  PartnerProductDetailsFormatted,
  PartnerProductFormatted,
  PartnerProductRowFormatted,
} from './index.h'

import { nay } from '~/shared/helpers'
import { getLabelPrice } from '~/shared/tools'

export function formatPartnerProductRow(
  partnerProductPage: Slice<PartnerProduct>
): PartnerProductRowFormatted {
  return {
    ...partnerProductPage,
    content: partnerProductPage.content.map(formatPartnerProductItem),
    isMoreThanOnePage: nay(partnerProductPage.last),
  }
}

export function formatPartnerProductItem(
  partnerProduct: PartnerProduct
): PartnerProductFormatted {
  return {
    ...partnerProduct,
    labelPrice: getPartnerProductLabelPrice(partnerProduct),
  }
}

export function formatPartnerProductDetailsItem(
  partnerProduct: PartnerProductDetails
): PartnerProductDetailsFormatted {
  return {
    ...partnerProduct,
    labelPrice: getPartnerProductLabelPrice(partnerProduct),
  }
}

export function getPartnerProductLabelPrice(
  partnerProduct: PartnerProductDetails | PartnerProduct
) {
  const { rented, isActive, purchaseInfo, free } = partnerProduct

  return (rented || free) && !isActive
    ? ''
    : getLabelPrice({
        purchaseInfo,
        free,
      })
}
